var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBoxLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83148 21.1242L4.83148 17.8984C3.93555 17.3204 3.48759 17.0313 3.24379 16.5839C3 16.1365 3 15.6034 3 14.5372V9.60595C3 8.94084 3 8.48318 3.05918 8.12436L11 13.8879V21.842C10.6828 21.6734 10.312 21.4342 9.83148 21.1242ZM13 21.842C13.3172 21.6734 13.688 21.4342 14.1685 21.1242L14.1685 21.1242L19.1685 17.8984C20.0644 17.3204 20.5124 17.0313 20.7562 16.5839C21 16.1365 21 15.6034 21 14.5372V9.60595C21 8.94083 21 8.48318 20.9408 8.12436L13 13.8879V21.842ZM19.6733 6.57307L12 12.1424L4.32671 6.57307C4.47692 6.47352 4.64444 6.36544 4.83148 6.24477L9.83148 3.01894C10.8844 2.33965 11.4108 2 12 2C12.5892 2 13.1156 2.33965 14.1685 3.01894L19.1685 6.24477C19.3556 6.36544 19.5231 6.47352 19.6733 6.57307Z",
    fill: "#1B92FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBoxLarge);
export default __webpack_public_path__ + "static/media/ic_box_large.2db1efc5d9c511e3ec42ca19a1e84c47.svg";
export { ForwardRef as ReactComponent };